import { render, staticRenderFns } from "./Resize.vue?vue&type=template&id=6cdf3829&scoped=true&"
import script from "./Resize.vue?vue&type=script&lang=js&"
export * from "./Resize.vue?vue&type=script&lang=js&"
import style0 from "./Resize.vue?vue&type=style&index=0&id=6cdf3829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf3829",
  null
  
)

export default component.exports